import React from 'react';
import _ from 'lodash';
import { priceFormatterV3 } from '../../../settings/themeSettings';
import SectionHeader from '../components/SectionHeader';
import BarChart from '../../../components/charts/BarChart';
import PieChart from '../../../components/charts/PieChart';

const GraphiquesSection = ({ dashboardData, journalVenteData }) => {
    const totalCATourisme = Number(dashboardData?.totalPaiementTourisme) || 0;

    // Utiliser les données du journal de vente pour la billetterie
    const billetterieJournal = journalVenteData || [];
    const billetterieFiltered = billetterieJournal.filter(item =>
        item.type_transaction === 'billetterie' ||
        item.service === 'billetterie' ||
        !item.type_transaction
    );
    const dataToUse = billetterieFiltered.length > 0 ? billetterieFiltered : billetterieJournal;

    const totalCABilletterie = Number(_.sumBy(dataToUse, (item) => Number(item.montant_vente) || Number(item.tarif) || 0)) || 0;
    const totalCAGlobal = totalCATourisme + totalCABilletterie;

    const totalDeboursTourisme = Number(dashboardData?.totalFraisTourisme) || 0;
    const totalDeboursBilletterie = Number(_.sumBy(dataToUse, (item) => Number(item.montant_achat) || Number(item.debours) || 0)) || 0;
    const totalDeboursGlobal = totalDeboursTourisme + totalDeboursBilletterie;

    const margeTourisme = totalCATourisme - totalDeboursTourisme;
    const margeBilletterie = totalCABilletterie - totalDeboursBilletterie;
    const margeGlobale = margeTourisme + margeBilletterie;

    const pourcentageMargeTourisme = totalCATourisme > 0 ? ((margeTourisme / totalCATourisme) * 100).toFixed(1) : 0;
    const pourcentageMargeBilletterie = totalCABilletterie > 0 ? ((margeBilletterie / totalCABilletterie) * 100).toFixed(1) : 0;
    const pourcentageMargeGlobale = totalCAGlobal > 0 ? ((margeGlobale / totalCAGlobal) * 100).toFixed(1) : 0;

    return (
        <div className="analysis-section">
            <SectionHeader
                title="📈 GRAPHIQUES : ANALYSE DES CHIFFRES D'AFFAIRES ET MARGE D'ACTIVITES"
                pdfData={[
                    { metrique: "Tourisme", montant: totalCATourisme, pourcentage: `${pourcentageMargeTourisme}%`, marge: margeTourisme },
                    { metrique: "Billetterie", montant: totalCABilletterie, pourcentage: `${pourcentageMargeBilletterie}%`, marge: margeBilletterie }
                ]}
                pdfFilename="graphiques-analyse-ca-marge.pdf"
                pdfTitle="Graphiques : Analyse CA et Marge"
                pdfTableHeaders={["Métrique", "Montant", "Taux de Marge", "Marge"]}
            />

            {/* Comparatif CA et Répartition */}
            <div className="charts-container">
                {/* Graphique en barres pour visualiser CA et Marges */}
                <div className="chart-card">
                    <h4 className="chart-title">COMPARATIF CHIFFRE D'AFFAIRES ET MARGES</h4>
                    <BarChart
                        identifier="barchart-ca-marges"
                        data={[
                            { category: 'Tourisme', value1: totalCATourisme, value2: margeTourisme },
                            { category: 'Billetterie', value1: totalCABilletterie, value2: margeBilletterie }
                        ]}
                        title="CA vs Marges par Activité"
                    />
                </div>

                {/* Graphique en secteurs pour répartition du CA */}
                <div className="chart-card">
                    <h4 className="chart-title">RÉPARTITION DU CHIFFRE D'AFFAIRES</h4>
                    <PieChart
                        identifier="piechart-ca-repartition"
                        data={[
                            { category: 'Tourisme', value: totalCATourisme },
                            { category: 'Billetterie', value: totalCABilletterie }
                        ]}
                        title="Répartition du CA Global"
                    />
                </div>
            </div>

            <div className="table-container-prof">
                <div className="table-title-prof">ANALYSE COMPARATIVE CHIFFRE D'AFFAIRES ET MARGES</div>
                <table className="professional-table">
                    <thead>
                        <tr>
                            <th className="text-left">INDICATEUR GRAPHIQUE</th>
                            <th className="text-right">TOURISME</th>
                            <th className="text-right">BILLETTERIE</th>
                            <th className="text-right">TOTAL</th>
                            <th className="text-right">REPARTITION</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-left"><strong>CHIFFRE D'AFFAIRES</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalCATourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalCABilletterie)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalCAGlobal)}</td>
                            <td className="percentage-cell">100.0%</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>DEBOURS</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalDeboursTourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalDeboursBilletterie)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalDeboursGlobal)}</td>
                            <td className="percentage-cell">{totalCAGlobal > 0 ? ((totalDeboursGlobal / totalCAGlobal) * 100).toFixed(1) : 0}%</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>MARGE</strong></td>
                            <td className="currency-cell">{priceFormatterV3(margeTourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeBilletterie)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeGlobale)}</td>
                            <td className="percentage-cell">{pourcentageMargeGlobale}%</td>
                        </tr>
                        <tr className="subtotal-row-prof">
                            <td className="text-left"><strong>TAUX DE MARGE</strong></td>
                            <td className="percentage-cell">{pourcentageMargeTourisme}%</td>
                            <td className="percentage-cell">{pourcentageMargeBilletterie}%</td>
                            <td className="percentage-cell">{pourcentageMargeGlobale}%</td>
                            <td className="percentage-cell">-</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="table-container-prof">
                <div className="table-title-prof">RATIOS DE PERFORMANCE PAR ACTIVITE</div>

                <div className="charts-container" style={{ margin: '20px 0' }}>
                    {/* Graphique ratios */}
                    <div className="chart-card">
                        <h4 className="chart-title">RATIOS DE PERFORMANCE PAR ACTIVITÉ</h4>
                        <BarChart
                            identifier="barchart-ratios-performance"
                            data={[
                                { category: 'Ratio Marge/CA (%)', value1: parseFloat(pourcentageMargeTourisme) || 0, value2: parseFloat(pourcentageMargeBilletterie) || 0 },
                                { category: 'Ratio Débours/CA (%)', value1: totalCATourisme > 0 ? ((totalDeboursTourisme / totalCATourisme) * 100) : 0, value2: totalCABilletterie > 0 ? ((totalDeboursBilletterie / totalCABilletterie) * 100) : 0 },
                                { category: 'Poids dans CA Global (%)', value1: totalCAGlobal > 0 ? ((totalCATourisme / totalCAGlobal) * 100) : 0, value2: totalCAGlobal > 0 ? ((totalCABilletterie / totalCAGlobal) * 100) : 0 }
                            ]}
                            title="Ratios de Performance par Activité"
                        />
                    </div>
                </div>

                <table className="professional-table">
                    <thead>
                        <tr>
                            <th className="text-left">RATIO DE PERFORMANCE</th>
                            <th className="text-right">TOURISME</th>
                            <th className="text-right">BILLETTERIE</th>
                            <th className="text-right">ECART</th>
                            <th className="text-left">INTERPRETATION</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-left"><strong>RATIO MARGE/CA</strong></td>
                            <td className="percentage-cell">{pourcentageMargeTourisme}%</td>
                            <td className="percentage-cell">{pourcentageMargeBilletterie}%</td>
                            <td className="percentage-cell">{Math.abs(parseFloat(pourcentageMargeTourisme) - parseFloat(pourcentageMargeBilletterie)).toFixed(1)}%</td>
                            <td className="text-left">{parseFloat(pourcentageMargeTourisme) > parseFloat(pourcentageMargeBilletterie) ? "Tourisme plus rentable" : "Billetterie plus rentable"}</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>RATIO DEBOURS/CA</strong></td>
                            <td className="percentage-cell">{totalCATourisme > 0 ? ((totalDeboursTourisme / totalCATourisme) * 100).toFixed(1) : 0}%</td>
                            <td className="percentage-cell">{totalCABilletterie > 0 ? ((totalDeboursBilletterie / totalCABilletterie) * 100).toFixed(1) : 0}%</td>
                            <td className="percentage-cell">{Math.abs((totalCATourisme > 0 ? (totalDeboursTourisme / totalCATourisme) * 100 : 0) - (totalCABilletterie > 0 ? (totalDeboursBilletterie / totalCABilletterie) * 100 : 0)).toFixed(1)}%</td>
                            <td className="text-left">Coût des prestations</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>POIDS DANS CA GLOBAL</strong></td>
                            <td className="percentage-cell">{totalCAGlobal > 0 ? ((totalCATourisme / totalCAGlobal) * 100).toFixed(1) : 0}%</td>
                            <td className="percentage-cell">{totalCAGlobal > 0 ? ((totalCABilletterie / totalCAGlobal) * 100).toFixed(1) : 0}%</td>
                            <td className="percentage-cell">-</td>
                            <td className="text-left">Contribution au CA</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr className="total-row-prof">
                            <td className="text-left"><strong>PERFORMANCE GLOBALE</strong></td>
                            <td className="currency-cell">{priceFormatterV3(margeTourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeBilletterie)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeGlobale)}</td>
                            <td className="text-left"><strong>Marge totale générée</strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

export default GraphiquesSection;
